<template>
	<v-card color="white" tile class="pa-4">
		<h3 class="cn-font light grey--text mb-6">Manage User</h3>
		<p>			
			<v-btn @click="resetPassword" color="accent" class="mr-2">Send Password Reset</v-btn>
			<v-btn @click="sendVerifyEmail" color="accent" class="mr-2">Send Email Verification</v-btn>
			<span v-if="sent">Sent!</span>
		</p>
	</v-card>
</template>

<script>
	import Vuex from "vuex";
	export default {
		name: "UserManagementButtons", 
		props: {
			id: {type: String}
		}, 
		data: () => ({
			sent: false,

		}),
		computed:{
			...Vuex.mapState({
				user(state){ 
					var id = this.id;
					return state.users.find( find => find.id == id )
				} 				
			})
		},
		methods: {
			reset(){
				this.sent = false;
				this.error = false;				
			},
			resetPassword(){
				this.reset();
				this.$store.dispatch("mail/sendPasswordResetEmail", this.user.email ).then(() => {
					this.sent = true;
				}).catch(( )=>{
					this.error = true;
				})
			},
			sendVerifyEmail(){
				this.reset();
				this.$store.dispatch("mail/verifyUserEmail", this.id ).then( () => {
					this.sent = true;
				}).catch(() => {
					this.error = true;
				})
			}
		}
	}
</script>